import React from 'react';
import { DiscussionTop, DesignDate } from './styles';

interface Props {
  date: string;
}

const DateSeparator: React.FC<Props> = ({ date }) => {
  return (
    <DiscussionTop>
      <DesignDate>
        <span>{date}</span>
      </DesignDate>
    </DiscussionTop>
  );
};

export default React.memo(DateSeparator);
